import React from 'react'
import api, { MetadataEntity } from 'api'
import { RouteComponentProps } from 'react-router'
import DataTable from './DataTable'
import DataView from './DataView'
import { AppTabs } from 'components/AppTabs'
import {appModule} from 'services/module'
import {EntityPageTable} from './EntityPageTable'

const tabs: string[] = ['数据表', '数据视图']

export default class extends React.Component<RouteComponentProps<any> & IPage> {
	state = { tabIndex: 0 }

	// 切换tab
	tabChg = (tabIndex: number) => {
		this.setState({ tabIndex })
	}
	// 编辑数据表
	callBack = (data: MetadataEntity) => {
		this.props.history.push(`/modeling/entity/${data.id}?entityId=${data.id}&application=${data.application}`)
	}
	renderPage = () => {
		switch (this.state.tabIndex) {
			case 1:
				return (
					<DataView
						key={this.state.tabIndex}
						systemCode={appModule.getCurrentModelingSystem().code}
						callBack={data => this.callBack(data)}
					/>
				) //  数据视图
			default:
				return <DataTable key={this.state.tabIndex} callBack={(data)=>this.callBack(data)}/> // 数据表
		}
	}
	render() {
		return (
			<div style={{ width: '100%', height: '100%' }} key={appModule.getCurrentModelingSystem().code}>
				<AppTabs tabs={tabs} onChange={this.tabChg}></AppTabs>
				<div style={{ display: 'flow-root', flexDirection: 'row', height: 'calc(100% - 45px)' }}>
					<EntityPageTable/>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/entity/EntityPage.tsx